"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var AchieveFilled = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M512 64c247.424 0 448 200.576 448 448S759.424 960 512 960 64 759.424 64 512 264.576 64 512 64zm243.499 289.835a42.667 42.667 0 00-60.331 0L450.347 598.613 352.34 484.672l-2.389-2.56a42.667 42.667 0 00-62.293 58.197l128 148.843 2.389 2.56a42.667 42.667 0 0060.117-.213L755.5 414.165l2.496-2.709a42.667 42.667 0 00-2.496-57.621z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
AchieveFilled.displayName = "AchieveFilled";
var _default = exports["default"] = AchieveFilled;